export default __webpack_public_path__ + "static/media/cow.f4e363bc.svg";